/**
 * Official Customer and User Status Constants (aligned with database schema & official specification)
 */
export const CUSTOMER_STATUS = {
  INACTIVE: 'inactive',           // Invitado / Sin Clave (Pre-cargado)
  PENDING_APPROVAL: 'pending_approval', // Pendiente por Auditar
  REQUIRES_VISIT: 'requires_visit',     // Requiere Visita de Campo
  ACTIVE: 'active',               // Activo / Operativo
  DISABLED: 'disabled',           // Deshabilitado / Bloqueado
  REJECTED: 'rejected',           // Rechazado / No Aprobado
};

export const CUSTOMER_STATUS_LABELS = {
  [CUSTOMER_STATUS.INACTIVE]: 'status_inactive',
  [CUSTOMER_STATUS.PENDING_APPROVAL]: 'status_pending_approval',
  [CUSTOMER_STATUS.REQUIRES_VISIT]: 'status_requires_visit',
  [CUSTOMER_STATUS.ACTIVE]: 'status_active',
  [CUSTOMER_STATUS.DISABLED]: 'status_disabled',
  [CUSTOMER_STATUS.REJECTED]: 'status_rejected',
};
